import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a67f8ea2&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=a67f8ea2&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=a67f8ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67f8ea2",
  null
  
)

export default component.exports